import { Box, Button, Typography, styled } from '@mui/material';
import { Column, FixedColumn } from 'further-ui/components/Layout';
import dataRoomShowcaseImg from 'assets/images/data-room-showcase.png';

const ShowcaseImage = styled('img')({
  width: '100%',
  maxWidth: 850,
});

const PaddedColumn = styled(Column)(({ theme }) => {
  const spacingToPx = (size: keyof typeof theme.spacingSizes) =>
    theme.spacingSizes[size] * 8;
  const offsetAbove =
    2 + // search bar
    spacingToPx('xl') + // Page Content padding top + bottom
    44 + // page header row (approx)
    spacingToPx('lg') + // Wrapper gap between header and TabsPanel
    44 + // tabs bar (approx)
    spacingToPx('lg'); // TabsPanel contentSpacing between tabs and content

  return {
    height: `calc(100vh - ${offsetAbove}px)`,
    overflow: 'hidden',
    paddingTop: theme.spacing(theme.spacingSizes.xxxl),
  };
});

type Props = {
  onAddDataRoom: () => void;
  creating?: boolean;
  canCreate?: boolean;
};

const NoDataRoom: React.FC<Props> = ({
  onAddDataRoom,
  creating,
  canCreate,
}) => {
  return (
    <PaddedColumn centered spacing="xxl">
      <FixedColumn fixedWidth="md">
        <Column spacing="lg" centered>
          <Column spacing="xs" centered>
            <Typography variant="h4">
              Showcase this opportunity with a data room
            </Typography>
            <Typography variant="body2" align="center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
              sollicitudin id metus sit amet scelerisque.
            </Typography>
          </Column>
          <Box>
            {canCreate && (
              <Button
                loading={creating}
                onClick={onAddDataRoom}
                variant="contained"
                size="large"
              >
                Add data room
              </Button>
            )}
          </Box>
        </Column>
      </FixedColumn>
      <ShowcaseImage src={dataRoomShowcaseImg} alt="" />
    </PaddedColumn>
  );
};

export default NoDataRoom;
